// Libraries
import { Icon } from '@chakra-ui/react';
import { Fragment } from 'react';
// Type
import { BearingLogoProps, LogoType, LogoViewBox } from './BearingLogo.type';

/**
 * Component that renders the Bearing logo.
 * @param {IconProps} props - The IconProps for the BearingLogo component.
 * @param {LogoType} props.logoType - The icon type for BearingLogo component.
 * @returns {ReactElement} The BearingLogo component.
 */
export const BearingLogo = (props: BearingLogoProps) => {
  const { logoType = LogoType.base, ...rest } = props;
  return (
    <Icon viewBox={LogoViewBox[logoType]} fill='transparent' {...rest} id='bearingLogo'>
      {logoType === LogoType.name && (
        <Fragment>
          <path d='M214 22.7324H0V21.0405H214V22.7324Z' fill='#25CAD2' />
          <path d='M96.1768 12.0974V17.6796H171.367L180.722 5.63721L96.1768 12.0974Z' fill='#25CAD2' />
          <path
            d='M8.60599 55.4862H11.2491C14.2066 55.4862 17.3214 54.7645 17.3214 51.1572C17.3214 47.4865 13.7975 46.9531 10.9027 46.9531H8.60599V55.4862ZM8.60599 44.6944H9.61287C12.6019 44.6944 15.1506 44.3494 15.1506 40.6789C15.1506 37.1025 12.885 36.726 9.64435 36.726H8.60599V44.6944ZM5.96289 34.2793H9.86435C14.1751 34.2793 17.7934 35.8477 17.7934 40.6789C17.7934 42.5924 17.0697 44.2238 15.465 45.2906C18.2968 45.9808 19.9643 48.5218 19.9643 51.3454C19.9643 56.0509 16.1572 57.9333 11.4691 57.9333H5.96289V34.2793Z'
            fill='#829FAA'
          />
          <path
            d='M28.2402 34.2791H40.5424V36.726H30.8833V43.7531H40.2592V46.2003H30.8833V55.4861H40.5424V57.9332H28.2402V34.2791Z'
            fill='#829FAA'
          />
          <path
            d='M57.188 39.2986L53.1291 48.7727H61.1524L57.188 39.2986ZM52.0594 51.2198L49.1963 57.9333H46.3018L57.251 33.1497L67.9172 57.9333H64.9909L62.1908 51.2198H52.0594Z'
            fill='#829FAA'
          />
          <path
            d='M190.965 39.0786L186.906 48.5527H194.93L190.965 39.0786ZM185.837 50.9998L182.974 57.7133H180.079L191.028 32.9297L201.695 57.7133H198.768L195.968 50.9998H185.837Z'
            fill='#829FAA'
          />
          <path
            d='M77.5464 45.2278H78.3644C81.3535 45.2278 84.3738 44.6631 84.3738 40.9928C84.3738 37.1027 81.5107 36.7259 78.333 36.7259H77.5464V45.2278ZM77.5464 57.9333H74.9033V34.2793H78.333C82.8322 34.2793 87.0169 35.471 87.0169 40.8045C87.0169 44.4433 84.7202 47.0159 81.0703 47.33L88.6216 57.9333H85.3808L78.2072 47.5493H77.5464V57.9333Z'
            fill='#829FAA'
          />
          <path d='M99.0689 57.9333H96.4258V34.2793H99.0689V57.9333Z' fill='#829FAA' />
          <path d='M210.08 57.7136H207.437V34.0596H210.08V57.7136Z' fill='#829FAA' />
          <path
            d='M108.444 33.2754L126.945 52.6002V34.2794H129.588V59L111.087 39.7065V57.9334H108.444V33.2754Z'
            fill='#829FAA'
          />
          <path
            d='M160.362 46.0436C160.425 49.2433 160.079 51.8785 157.908 54.3884C155.737 56.898 152.434 58.3411 149.13 58.3411C142.46 58.3411 136.922 52.8197 136.922 46.169C136.922 39.3926 142.46 33.8713 149.287 33.8713C153.44 33.8713 156.807 35.7222 159.324 38.985L157.405 40.7731C155.423 37.9811 152.748 36.3183 149.256 36.3183C143.844 36.3183 139.565 40.8672 139.565 46.2003C139.565 48.7101 140.572 51.0944 142.334 52.8825C144.064 54.608 146.581 55.8944 149.067 55.8944C153.189 55.8944 157.531 52.8825 157.531 48.4904H150.483V46.0436H160.362Z'
            fill='#829FAA'
          />
          <path d='M165.665 0H108.53V8.70992L165.665 4.3442V0Z' fill='#25CAD2' />
        </Fragment>
      )}
      {logoType === LogoType.base && (
        <path
          d='M1124.45 119.796H0V110.88H1124.45V119.796Z M505.353 63.7511V93.1685H900.436L949.593 29.7071L505.353 63.7511Z M870.476 -9.15527e-05H570.267V45.8999L870.476 22.8932V-9.15527e-05Z'
          fill='#20CBD4'
        />
      )}
      {logoType === LogoType.short && (
        <path
          d='M1124.45 119.796H410V110.88H1020.45V119.796Z M505.353 63.7511V93.1685H900.436L949.593 29.7071L505.353 63.7511Z M870.476 -9.15527e-05H570.267V45.8999L870.476 22.8932V-9.15527e-05Z'
          fill='#20CBD4'
        />
      )}
      {logoType === LogoType.ghost && (
        <Fragment>
          <path
            d='M18.32 0v13l83.744-6.5V0H18.319z M0 26v-7.8l123-9.1L109.915 26H0z'
            fill='url(#a)'
            fillOpacity='.46'
          />
          <defs>
            <linearGradient id='a' x1='144.5' y1='6' x2='-30' y2='19.5' gradientUnits='userSpaceOnUse'>
              <stop stopColor='#8484A0' />
              <stop offset='1' stopColor='#DAD9E2' />
            </linearGradient>
          </defs>
        </Fragment>
      )}
    </Icon>
  );
};
